<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>基础信息</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>教师编号：</p>
                    <a-input class="input" v-model="info.teacherId" :disabled="type!='add'"/>
                </div>
                <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>教师姓名：</p>
                    <a-input class="input" v-model="info.teacherName" :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>部门：</p>
                    <a-tree-select
                        class="input"
                        showSearch
                        v-model="selectedDeployment"
                        labelInValue
                        :treeData="departmentTree"
                        :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                        allowClear
                        treeNodeFilterProp="title"
                        treeDefaultExpandAll
                        @change="onChangeDep"
                        >
                    </a-tree-select>
                </div>
                <div class="input-box">
                    <p>证件类型：</p>
                    <a-select class="input" allowClear v-model="info.identityTypeCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in zjlxArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>证件号：</p>
                    <a-input class="input" v-model="info.identityNumber" :disabled="type=='look'" @change="identityChange"/>
                </div>
                <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>性别：</p>
                    <a-select class="input" allowClear v-model="info.genderCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>出生年月：</p>
                    <a-date-picker class="input" v-model="info.birthday" @change="(date, dateString)=>{info.birthday=dateString}" :disabled="type=='look'"/>
                </div>
                
                <div class="input-box">
                    <p>联系电话：</p>
                    <a-input class="input" v-model="info.phone" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>邮箱：</p>
                    <a-input class="input" v-model="info.email" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>国籍：</p>
                    <a-select class="input" allowClear v-model="info.nationalityCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in gjArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box input-box-center">
                    <p>籍贯：</p>
                    <a-select class="input input-min" allowClear v-model="xzqCode1" @change="xzqChange1" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in xzqhArr1" :key="index" :value="item.code">{{item.name}}</a-select-option>
                    </a-select>
                    <a-select class="input input-min" allowClear v-model="xzqCode2" @change="xzqChange2" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in xzqhArr2" :key="index" :value="item.code">{{item.name}}</a-select-option>
                    </a-select>
                    <a-select class="input input-min" allowClear v-model="xzqCode3" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in xzqhArr3" :key="index" :value="item.code">{{item.name}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>民族：</p>
                    <a-select class="input" allowClear v-model="info.nationGroupCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in mzArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box input-box-center">
                    <p>出生地：</p>
                    <a-select class="input input-min" allowClear v-model="csdCode1" @change="csdChange1" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in csdArr1" :key="index" :value="item.code">{{item.name}}</a-select-option>
                    </a-select>
                    <a-select class="input input-min" allowClear v-model="csdCode2" @change="csdChange2" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in csdArr2" :key="index" :value="item.code">{{item.name}}</a-select-option>
                    </a-select>
                    <a-select class="input input-min" allowClear v-model="csdCode3" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in csdArr3" :key="index" :value="item.code">{{item.name}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>人员类别：</p>
                    <a-select class="input" allowClear v-model="info.staffCategoryCode" @change="isPostDoctor" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in rylbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>专业技术职务：</p>
                    <a-select class="input" allowClear v-model="info.technicalPositionCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in zwArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>专业技术职称：</p>
                    <a-select class="input" allowClear v-model="info.technicalTitleCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in zcArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>专技职级：</p>
                    <a-select class="input" allowClear v-model="info.professRankCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in zjzjArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>导师类别：</p>
                    <a-select class="input" allowClear v-model="info.tutorCategoryCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in dslbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>是否专业学位导师：</p>
                    <a-select class="input" allowClear v-model="info.isProfessTutor" :disabled="type=='look'">
                        <a-select-option :value="false">否</a-select-option>
                        <a-select-option :value="true">是</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>学科方向：</p>
                    <a-select class="input" allowClear v-model="info.subjectDirectionCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in xkfxArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>学术头衔：</p>
                    <a-input class="input" v-model="info.academicTitle" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>最高学历：</p>
                    <a-select class="input" allowClear v-model="info.highestEducationCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in xlArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>最高学位：</p>
                    <a-select class="input" allowClear v-model="info.highestDegreeCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in xwArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>最高学位获得单位：</p>
                    <a-input class="input" v-model="info.highestDegreeOrg" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>实际岗位：</p>
                    <a-select class="input" allowClear v-model="info.actualPosition" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in gwArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>管理职级：</p>
                    <a-select class="input" allowClear v-model="info.managementRankCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in glzjArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>首聘时间：</p>
                    <a-date-picker class="input" v-model="info.firstHireDate"  @change="(date, dateString)=>{info.firstHireDate=dateString}" :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p>政治面貌：</p>
                    <a-select class="input" allowClear v-model="info.politicalState" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in zzmmArr" :key="index" :value="item.dataName">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>入党团年月：</p>
                    <a-month-picker class="input" v-model="info.joinPartyDate"  @change="(date, dateString)=>{info.joinPartyDate=dateString}" :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p>现从事专业：</p>
                    <a-input class="input" v-model="info.engagedProfess" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>参加工作年月：</p>
                    <a-month-picker class="input" v-model="info.startWorkDate"  @change="(date, dateString)=>{info.startWorkDate=dateString}" :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p>转干时间：</p>
                    <a-date-picker class="input" v-model="info.turnCadreDate"  @change="(date, dateString)=>{info.turnCadreDate=dateString}" :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p>从教时间：</p>
                    <a-date-picker class="input" v-model="info.startTeachDate"  @change="(date, dateString)=>{info.startTeachDate=dateString}" :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p>是否具备海外经历：</p>
                    <a-select class="input" allowClear v-model="info.hasOverseaExp" :disabled="type=='look'">
                        <a-select-option :value="false">否</a-select-option>
                        <a-select-option :value="true">是</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>进校时间：</p>
                    <a-date-picker class="input" v-model="info.entryDate"  @change="(date, dateString)=>{info.entryDate=dateString}" :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p>是否在职：</p>
                    <a-select class="input" allowClear v-model="info.onJob" :disabled="type=='look'">
                        <a-select-option :value="false">否</a-select-option>
                        <a-select-option :value="true">是</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>离职时间：</p>
                    <a-date-picker class="input" v-model="info.quitDate"  @change="(date, dateString)=>{info.quitDate=dateString}" :disabled="type=='look'"/>
                </div>
                
                <div class="input-box input-box-big">
                    <p>联系地址：</p>
                    <a-input class="input" v-model="info.contactAddress" :disabled="type=='look'" />
                </div>
                <div class="input-box input-box-big">
                    <p>备注：</p>
                    <a-textarea class="input" v-model="info.remark" :disabled="type=='look'" :rows="4" />
                </div>

            </div>
        </div>
        <div class="info-box" v-if="postDoctor">
            <div class="info-title">
                <h3>博士后信息</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box">
                    <p>专业方向：</p>
                    <a-input v-model="info.majorField" class="input" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>合作导师姓名：</p>
                    <a-input v-model="info.mentorTeacherName" class="input" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>导师工号：</p>
                    <a-input v-model="info.mentorTeacherId" class="input" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>所在二级专业：</p>
                    <a-input v-model="info.majorLevel2" class="input" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>进站时间：</p>
                    <a-date-picker valueFormat="YYYY-MM-DD" v-model="info.inboudDate" class="input" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>出站时间：</p>
                    <a-date-picker valueFormat="YYYY-MM-DD" v-model="info.outboudDate" class="input" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>退站时间：</p>
                    <a-date-picker valueFormat="YYYY-MM-DD" v-model="info.exitDate" class="input" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>入学方式：</p>
                    <a-input v-model="info.enrollmentModel" class="input" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>博士毕业学校：</p>
                    <a-input v-model="info.doctoralSchool" class="input" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>硕士毕业学校：</p>
                    <a-input v-model="info.masterSchool" class="input" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>本科毕业学校：</p>
                    <a-input v-model="info.undergraduateSchool" class="input" :disabled="type=='look'" />
                </div>
            </div>
        </div>    
        <div class="info-box">
            <div class="info-title">
                <a-button type="primary" icon="plus" @click="educationAdd" v-if="type!='look'">新增</a-button>
                <h3>教育经历</h3>
                <p></p>
            </div>
            <a-table
                v-if="educationShow"
                :columns="educationColumns" 
                :data-source="educationData" 
                :pagination="false"
                bordered>
                <template slot="startDate" slot-scope="text,record">
                    <span v-if="!record.isInput">{{text}}</span>
                    <a-date-picker class="input-box" v-if="record.isInput" v-model="record.startDate" @change="(date,dateStr)=>{record.startDate=dateStr}"/>
                </template>
                <template slot="endDate" slot-scope="text,record">
                    <span v-if="!record.isInput">{{text}}</span>
                    <a-date-picker class="input-box" v-if="record.isInput" v-model="record.endDate" @change="(date,dateStr)=>{record.endDate=dateStr}"/>
                </template>
                <template slot="schoolName" slot-scope="text,record">
                    <span v-if="!record.isInput">{{text}}</span>
                    <a-input class="input-box" v-if="record.isInput" v-model="record.schoolName"/>
                </template>
                <template slot="educationCode" slot-scope="text,record">
                    <!-- <span v-if="!record.isInput">{{text}}</span> -->
                    <a-select class="input-box" allowClear v-model="record.educationCode" :disabled="!record.isInput">
                        <a-select-option v-for="(item,index) in xlArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </template>
                <template slot="degreeCode" slot-scope="text,record">
                    <a-select class="input-box" :disabled="!record.isInput" allowClear v-model="record.degreeCode">
                        <a-select-option v-for="(item,index) in xwArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </template>
                <template slot="is985" slot-scope="text,record">
                    <a-select class="input-box" :disabled="!record.isInput" allowClear v-model="record.is985">
                        <a-select-option :key="index" :value="1">是</a-select-option>
                        <a-select-option :key="index" :value="0">否</a-select-option>
                    </a-select>
                </template>
                <template slot="id" slot-scope="text,record">
                    <a class="action-btn" v-if="record.isInput" @click="record.isInput=false;tableData(record,'educationData')">确定</a>
                    <a class="action-btn" v-if="!record.isInput" @click="record.isInput=true;tableData(record,'educationData')">编辑</a>
                    <a-divider type="vertical" v-if="!record.isInput"/>
                    <a class="action-btn" v-if="!record.isInput" @click="delEducation(record)">删除</a>
                </template>
            </a-table>
        </div>
        <div class="info-box">
            <div class="info-title">
                <a-button type="primary" icon="plus" @click="workAdd" v-if="type!='look'">新增</a-button>
                <h3>工作经历</h3>
                <p></p>
            </div>
            <a-table 
                :columns="workColumns" 
                :data-source="workData" 
                :pagination="false"
                bordered>
                <template slot="startDate" slot-scope="text,record">
                    <span v-if="!record.isInput">{{text}}</span>
                    <a-date-picker class="input-box" v-if="record.isInput" v-model="record.startDate" @change="(date,dateStr)=>{record.startDate=dateStr}"/>
                </template>
                <template slot="endDate" slot-scope="text,record">
                    <span v-if="!record.isInput">{{text}}</span>
                    <a-date-picker class="input-box" v-if="record.isInput" v-model="record.endDate" @change="(date,dateStr)=>{record.endDate=dateStr}"/>
                </template>
                <template slot="orgName" slot-scope="text,record">
                    <span v-if="!record.isInput">{{text}}</span>
                    <a-input class="input-box" v-if="record.isInput" v-model="record.orgName"/>
                </template>
                <template slot="technicalPositionCode" slot-scope="text,record">
                    <a-select class="input-box" :disabled="!record.isInput" allowClear v-model="record.technicalPositionCode">
                        <a-select-option v-for="(item,index) in zwArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </template>
                <template slot="technicalTitleCode" slot-scope="text,record">
                    <a-select class="input-box" :disabled="!record.isInput" allowClear v-model="record.technicalTitleCode">
                        <a-select-option v-for="(item,index) in zcArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </template>
                <template slot="mainAchievements" slot-scope="text,record">
                    <span v-if="!record.isInput">{{text}}</span>
                    <a-input class="input-box" v-if="record.isInput" v-model="record.mainAchievements"/>
                </template>
                <template slot="id" slot-scope="text,record">
                    <a class="action-btn" v-if="record.isInput" @click="record.isInput=false;tableData(record,'workData')">确定</a>
                    <a class="action-btn" v-if="!record.isInput" @click="record.isInput=true;tableData(record,'workData')">编辑</a>
                    <a-divider type="vertical" v-if="!record.isInput"/>
                    <a class="action-btn" v-if="!record.isInput" @click="delWork(record)">删除</a>
                </template>
            </a-table>
        </div>
        <div class="info-box" v-if="info.hasOverseaExp">
            <div class="info-title">
                <a-button type="primary" icon="plus" @click="overseasAdd" v-if="type!='look'">新增</a-button>
                <h3>海外经历</h3>
                <p></p>
            </div>
            <a-table 
                :columns="overseasColumns" 
                :data-source="overseasData" 
                :pagination="false"
                bordered>
                <template slot="startDate" slot-scope="text,record">
                    <span v-if="!record.isInput">{{text}}</span>
                    <a-date-picker class="input-box" v-if="record.isInput" v-model="record.startDate" @change="(date,dateStr)=>{record.startDate=dateStr}" :disabled="!record.isInput"/>
                </template>
                <template slot="endDate" slot-scope="text,record">
                    <span v-if="!record.isInput">{{text}}</span>
                    <a-date-picker class="input-box" v-if="record.isInput" v-model="record.endDate" @change="(date,dateStr)=>{record.endDate=dateStr}"/>
                </template>
                <template slot="countryCode" slot-scope="text,record">
                    <a-select class="input-box" :disabled="!record.isInput" allowClear v-model="record.countryCode">
                        <a-select-option v-for="(item,index) in gjArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </template>
                <template slot="schoolName" slot-scope="text,record">
                    <span v-if="!record.isInput">{{text}}</span>
                    <a-input class="input-box" v-if="record.isInput" v-model="record.schoolName"/>
                </template>
                <template slot="mainAchievements" slot-scope="text,record">
                    <span v-if="!record.isInput">{{text}}</span>
                    <a-input class="input-box" v-if="record.isInput" v-model="record.mainAchievements"/>
                </template>
                <template slot="id" slot-scope="text,record">
                    <a class="action-btn" v-if="record.isInput" @click="record.isInput=false;tableData(record,'overseasData')">确定</a>
                    <a class="action-btn" v-if="!record.isInput" @click="record.isInput=true;tableData(record,'overseasData')">编辑</a>
                    <a-divider type="vertical" v-if="!record.isInput"/>
                    <a class="action-btn" v-if="!record.isInput" @click="delOverseas(record)">删除</a>
                </template>
            </a-table>
        </div>
        <div class="btn-box">
            <a-button type="primary" @click="sub" v-if="type!='look'">提交</a-button>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { queryDepartmentTreeList } from '@/baseAPI/department'
    import { add,getXzqh,info,update } from '@/baseAPI/facultyTeacher'
    const educationColumns = [
        {
            title: '开始时间',
            dataIndex: 'startDate',
            scopedSlots: { customRender: 'startDate' },
            width:"13%",
            align:'center'
        },
        {
            title: '结束时间',
            dataIndex: 'endDate',
            scopedSlots: { customRender: 'endDate' },
            width:"13%",
            align:'center'
        },
        {
            title: '学校名称',
            dataIndex: 'schoolName',
            scopedSlots: { customRender: 'schoolName' },
            width:"25%",
            align:'center'
        },
        {
            title: '学历',
            dataIndex: 'educationCode',
            scopedSlots: { customRender: 'educationCode' },
            width:"13%",
            align:'center'
        },
        {
            title: '获得学位',
            dataIndex: 'degreeCode',
            scopedSlots: { customRender: 'degreeCode' },
            width:"13%",
            align:'center'
        },
        {
            title: '是否985',
            dataIndex: 'is985',
            scopedSlots: { customRender: 'is985' },
            width:"13%",
            align:'center'
        },
    ];
    const workColumns = [
        {
            title: '开始时间',
            dataIndex: 'startDate',
            scopedSlots: { customRender: 'startDate' },
            width:"15%",
            align:'center'
        },
        {
            title: '结束时间',
            dataIndex: 'endDate',
            scopedSlots: { customRender: 'endDate' },
            width:"15%",
            align:'center'
        },
        {
            title: '单位名称',
            dataIndex: 'orgName',
            scopedSlots: { customRender: 'orgName' },
            width:"18%",
            align:'center'
        },
        {
            title: '专业技术职务',
            dataIndex: 'technicalPositionCode',
            scopedSlots: { customRender: 'technicalPositionCode' },
            width:"15%",
            align:'center'
        },
        {
            title: '专业技术职称',
            dataIndex: 'technicalTitleCode',
            scopedSlots: { customRender: 'technicalTitleCode' },
            width:"15%",
            align:'center'
        },
        {
            title: '主要成果',
            dataIndex: 'mainAchievements',
            scopedSlots: { customRender: 'mainAchievements' },
            width:"15%",
            align:'center'
        },
    ];
    const overseasColumns = [
        {
            title: '出国时间',
            dataIndex: 'startDate',
            scopedSlots: { customRender: 'startDate' },
            width:"17%",
            align:'center'
        },
        {
            title: '回国时间',
            dataIndex: 'endDate',
            scopedSlots: { customRender: 'endDate' },
            width:"17%",
            align:'center'
        },
        {
            title: '出国国家',
            dataIndex: 'countryCode',
            scopedSlots: { customRender: 'countryCode' },
            width:"17%",
            align:'center'
        },
        {
            title: '所在学校/单位',
            dataIndex: 'schoolName',
            scopedSlots: { customRender: 'schoolName' },
            width:"20%",
            align:'center'
        },
        {
            title: '主要成果',
            dataIndex: 'mainAchievements',
            scopedSlots: { customRender: 'mainAchievements' },
            width:"20%",
            align:'center'
        },
    ];
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                type:'',
                educationColumns:[],
                educationData:[],
                educationShow:true,
                workColumns:[],
                workData:[],
                overseasColumns:[],
                overseasData:[],
                info:{
                    id:null,
                    teacherId:null,
                    teacherName:null,
                    genderCode:null,
                    birthday:null,
                    identityNumber:null,
                    phone:null,
                    email:null,
                    identityTypeCode:null,
                    nationalityCode:null,
                    nativePlaceCode:null,
                    technicalPositionCode:null,
                    technicalTitleCode:null,
                    tutorCategoryCode:null,
                    isProfessTutor:null,
                    subjectDirectionCode:null,
                    academicTitle:null,
                    highestEducationCode:null,
                    highestDegreeCode:null,
                    highestDegreeOrg:null,
                    hasOverseaExp:null,
                    entryDate:null,
                    quitDate:null,
                    onJob:true,
                    contactAddress:null,
                    expList:[],
                    staffCategoryCode:null,
                    birthPlaceCode:null,
                    nationGroupCode:null,
                    actualPosition:null,
                    managementRankCode:null,
                    professRankCode:null,
                    firstHireDate:null,
                    politicalState:null,
                    joinPartyDate:null,
                    engagedProfess:null,
                    startWorkDate:null,
                    turnCadreDate:null,
                    finalEducation:null,
                    startTeachDate:null,
                    remark:null,

                    majorField: null,
                    mentorTeacherId: null,
                    mentorTeacherName: null,
                    majorLevel2: null,
                    inboudDate: null,
                    outboudDate: null,
                    exitDate: null,
                    enrollmentModel: null,
                    doctoralSchool: null,
                    masterSchool: null,
                    undergraduateSchool: null
                },
                xbArr:[],
                zjlxArr:[],
                gjArr:[],
                zwArr:[],
                zcArr:[],
                dslbArr:[],
                xkfxArr:[],
                xlArr:[],
                xwArr:[],
                xzqhArr1:[],
                xzqhArr2:[],
                xzqhArr3:[],
                xzqCode1:null,
                xzqCode2:null,
                xzqCode3:null,
                csdArr1:[],
                csdArr2:[],
                csdArr3:[],
                csdCode1:null,
                csdCode2:null,
                csdCode3:null,
                departmentTree:[],
                selectedDeployment:{},
                mzArr:[],
                zjzjArr:[],
                rylbArr:[],
                glzjArr:[],
                gwArr:[],
                zzmmArr:[],
                postDoctor:false
            }
        },
        mounted () {
            queryDepartmentTreeList().then(res => {
                this.departmentTree = res.data
            })
            getDicts({dataCode:'XB',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
                this.info.genderCode=res.data.defaultValue[0]==''?null:res.data.defaultValue[0]
            })
            getDicts({dataCode:'ZJLX',status:true}).then(res=>{
                this.zjlxArr=res.data.dicts;
                this.info.identityTypeCode=res.data.defaultValue[0]==''?null:res.data.defaultValue[0]
            })
            getDicts({dataCode:'GJ',status:true}).then(res=>{
                this.gjArr=res.data.dicts;
                this.info.nationalityCode=res.data.defaultValue[0]==''?null:res.data.defaultValue[0]
            })
            getDicts({dataCode:'ZW',status:true}).then(res=>{
                this.zwArr=res.data.dicts;
                this.info.technicalPositionCode=res.data.defaultValue[0]==''?null:res.data.defaultValue[0]
            })
            getDicts({dataCode:'ZC',status:true}).then(res=>{
                this.zcArr=res.data.dicts;
                this.info.technicalTitleCode=res.data.defaultValue[0]==''?null:res.data.defaultValue[0]
            })
            getDicts({dataCode:'DSLB',status:true}).then(res=>{
                this.dslbArr=res.data.dicts;
                this.info.tutorCategoryCode=res.data.defaultValue[0]==''?null:res.data.defaultValue[0]
            })
            getDicts({dataCode:'XKFX',status:true}).then(res=>{
                this.xkfxArr=res.data.dicts;
                this.info.subjectDirectionCode=res.data.defaultValue[0]==''?null:res.data.defaultValue[0]
            })
            getDicts({dataCode:'XL',status:true}).then(res=>{
                this.xlArr=res.data.dicts;
                this.info.highestEducationCode=res.data.defaultValue[0]==''?null:res.data.defaultValue[0]
            })
            getDicts({dataCode:'XW',status:true}).then(res=>{
                this.xwArr=res.data.dicts;
                this.info.highestDegreeCode=res.data.defaultValue[0]==''?null:res.data.defaultValue[0]
            })
            getDicts({dataCode:'MZ',status:true}).then(res=>{
                this.mzArr=res.data.dicts;
                this.info.nationGroupCode=res.data.defaultValue[0]==''?null:res.data.defaultValue[0]
            })
            getDicts({dataCode:'ZJZJ',status:true}).then(res=>{
                this.zjzjArr=res.data.dicts;
                this.info.professRankCode=res.data.defaultValue[0]==''?null:res.data.defaultValue[0]
            })
            getDicts({dataCode:'RYLB',status:true}).then(res=>{
                this.rylbArr=res.data.dicts;
                this.info.staffCategoryCode=res.data.defaultValue[0]==''?null:res.data.defaultValue[0]
            })
            getDicts({dataCode:'GW',status:true}).then(res=>{
                this.gwArr=res.data.dicts;
                this.info.actualPosition=res.data.defaultValue[0]==''?null:res.data.defaultValue[0]
            })
            getDicts({dataCode:'GLZJ',status:true}).then(res=>{
                this.glzjArr=res.data.dicts;
                this.info.managementRankCode=res.data.defaultValue[0]==''?null:res.data.defaultValue[0]
            })
            getDicts({dataCode:'ZZMM',status:true}).then(res=>{
                this.zzmmArr=res.data.dicts;
            })
            getXzqh({status:true,lev:1}).then(res=>{
                this.xzqhArr1=res.data;
                this.csdArr1=res.data;
            })
            this.type=this.$route.query.type;
            this.educationColumns=this.deepCopy(educationColumns)
            this.workColumns=this.deepCopy(workColumns)
            this.overseasColumns=this.deepCopy(overseasColumns)
            if(this.type!='look'){
                let tableTitle={
                    title: '操作',
                    dataIndex: 'id',
                    scopedSlots: { customRender: 'id' }
                }
                this.educationColumns.push(tableTitle)
                this.workColumns.push(tableTitle)
                this.overseasColumns.push(tableTitle)
            }
            if(this.type!='add'){
                setTimeout(()=>{
                    info(this.$route.query.id).then(res=>{
                        this.info=res.data.data;
                        if(this.info.staffCategoryCode == '04'){
                            this.postDoctor = true
                        }

                        if(this.info.jg!=null){
                            this.xzqCode1=this.info.jg.codeLev1;
                            getXzqh({status:true,lev:2,code:this.xzqCode1}).then(res=>{
                                this.xzqhArr2=res.data;
                                for(let i=0;i<this.xzqhArr2.length;i++){
                                    if(this.xzqhArr2[i].code==this.info.jg.codeLev2){
                                        this.xzqCode2=this.info.jg.codeLev2;
                                        getXzqh({status:true,lev:3,code:this.xzqCode2}).then(res=>{
                                            this.xzqhArr3=res.data;
                                            for(let i=0;i<this.xzqhArr3.length;i++){
                                                if(this.xzqhArr3[i].code==this.info.nativePlaceCode){
                                                    this.xzqCode3=this.info.nativePlaceCode;
                                                }
                                            }
                                        })
                                    }
                                }
                            })
                        }
                        if(this.info.csd!=null){
                            this.csdCode1=this.info.csd.codeLev1;
                            getXzqh({status:true,lev:2,code:this.csdCode1}).then(res=>{
                                this.csdArr2=res.data;
                                for(let i=0;i<this.csdArr2.length;i++){
                                    if(this.csdArr2[i].code==this.info.csd.codeLev2){
                                        this.csdCode2=this.info.csd.codeLev2;
                                        getXzqh({status:true,lev:3,code:this.csdCode2}).then(res=>{
                                            this.csdArr3=res.data;
                                            for(let i=0;i<this.csdArr3.length;i++){
                                                if(this.csdArr3[i].code==this.info.birthPlaceCode){
                                                    this.csdCode3=this.info.birthPlaceCode;
                                                }
                                            }
                                        })
                                    }
                                }
                            })
                        }
                        this.educationData=[];
                        this.workData=[];
                        this.overseasData=[];
                        for(let i=0;i<this.info.expList.length;i++){
                            this.info.expList[i].isInput=false;
                            if(this.info.expList[i].expType==1){
                                this.educationData.push(this.info.expList[i]);
                            }else if(this.info.expList[i].expType==2){
                                this.workData.push(this.info.expList[i]);
                            }else if(this.info.expList[i].expType==3){
                                this.overseasData.push(this.info.expList[i]);
                            }
                        }
                        this.selectedDeployment = {}
                        if (this.info.orgCode) {
                            this.selectedDeployment.value = this.info.orgCode
                            this.selectedDeployment.label = this.info.orgName
                        }

                    })                
                },500)

            }
        },
        methods:{
            isPostDoctor(value){
                if(value == '04'){
                    this.postDoctor = true
                }else{
                    this.postDoctor = false
                }
            },
            educationAdd(){
                this.educationData.push({
                    expType:1,
                    startDate:'',
                    endDate:'',
                    schoolName:'',
                    educationCode:'',
                    degreeCode:'',
                    is985:'0',
                    isInput:true,
                })
            },
            delEducation(obj){
                this.educationData.splice(this.educationData.indexOf(obj),1)
            },
            workAdd(){
                this.workData.push({
                    expType:2,
                    startDate:'',
                    endDate:'',
                    orgName:'',
                    technicalPositionCode:'',
                    technicalTitleCode:'',
                    mainAchievements:'',
                    isInput:true,
                })
            },
            delWork(obj){
                this.workData.splice(this.workData.indexOf(obj),1)
            },
            overseasAdd(){
                this.overseasData.push({
                    expType:3,
                    startDate:'',
                    endDate:'',
                    countryCode:'',
                    schoolName:'',
                    mainAchievements:'',
                    isInput:true,
                })
            },
            delOverseas(obj){
                this.overseasData.splice(this.overseasData.indexOf(obj),1)
            },
            xzqChange1(){
                this.xzqCode2=null;
                this.info.nativePlaceCode=null;
                getXzqh({status:true,lev:2,code:this.xzqCode1}).then(res=>{
                    this.xzqhArr2=res.data;
                })
            },
            xzqChange2(){
                this.info.nativePlaceCode=null;
                getXzqh({status:true,lev:3,code:this.xzqCode2}).then(res=>{
                    this.xzqhArr3=res.data;
                })
            },
            csdChange1(){
                this.csdCode2=null;
                this.info.birthPlaceCode=null;
                getXzqh({status:true,lev:2,code:this.csdCode1}).then(res=>{
                    this.csdArr2=res.data;
                })
            },
            csdChange2(){
                this.info.birthPlaceCode=null;
                getXzqh({status:true,lev:3,code:this.csdCode2}).then(res=>{
                    this.csdArr3=res.data;
                })
            },
            sub(){
                if(this.xzqCode3!=null){
                    this.info.nativePlaceCode=this.xzqCode3
                }else if(this.xzqCode2!=null){
                    this.info.nativePlaceCode=this.xzqCode2
                }else{
                    this.info.nativePlaceCode=this.xzqCode1
                }
                if(this.csdCode3!=null){
                    this.info.birthPlaceCode=this.csdCode3
                }else if(this.csdCode2!=null){
                    this.info.birthPlaceCode=this.csdCode2
                }else{
                    this.info.birthPlaceCode=this.csdCode1
                }
                
                this.info.expList=[];
                for(let i=0;i<this.educationData.length;i++){
                    if(!this.educationData[i].isInput){
                        this.info.expList.push(this.educationData[i])
                    }else{
                        this.$notification['warning']({
                            message: '警告',
                            description:'教育经历当前有未确定的信息，请点击操作列中的确定按钮后提交',
                        });
                        return false;
                    }
                }
                for(let i=0;i<this.workData.length;i++){
                    if(!this.workData[i].isInput){
                        this.info.expList.push(this.workData[i])
                    }else{
                        this.$notification['warning']({
                            message: '警告',
                            description:'工作经历当前有未确定的信息，请点击操作列中的确定按钮后提交',
                        });
                        return false;
                    }
                }
                // for(let i=0;i<this.overseasData.length;i++){
                //     if(!this.overseasData[i].isInput){
                //         this.info.expList.push(this.overseasData[i])
                //     }else{
                //         this.$notification['warning']({
                //             message: '警告',
                //             description:'海外经历当前有未确定的信息，请确认后提交',
                //         });
                //         return false;
                //     }
                // }
                var isSub=true;
                var arr=['schoolYear','semester','courseName','credit']
                console.log(this.info)
                for(let i=0;i<arr.length;i++){
                    if(this.info[arr[i]]==null||this.info[arr[i]]===''){
                        isSub=false;
                        break;
                    }
                }
                if(this.info.teacherId!=null&&this.info.teacherName!=null&&this.info.identityNumber!=null&&this.info.genderCode!=null&&this.info.orgCode!=null){
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增教师信息成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改教师信息成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'教师编号，教师姓名，身份证号，性别，部门为必填选项',
                    });
                }
            },
            identityChange(){
                if(this.info.identityNumber.length==18&&this.info.identityTypeCode.indexOf('JMSFZ')>-1){
                    var year=this.info.identityNumber.slice(6,10);
                    var month=this.info.identityNumber.slice(10,12);
                    var day=this.info.identityNumber.slice(12,14);
                    this.info.birthday=year+'-'+month+'-'+day;
                    this.info.genderCode=this.info.identityNumber.slice(16,17)%2==0?'0':'1'
                }
            },
            onChangeDep (obj) {
                this.selectedDeployment=obj;
                this.info.orgCode = obj.value;
                this.info.orgName = obj.label;
            },
            tableData(record,name){
                var num=this[name].indexOf(record);
                this[name].splice(num,1,record);
            },
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
    }
    .info-main .input-box-center{
        width: 66%;
    }
    .info-main .input-box-big{
        width: 99%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 12rem);
    }
    .info-main .input-box .input-min{
        width: calc(32.7% - 4rem);
        margin-right: 1%;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .ant-table-wrapper .ant-select-disabled{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .ant-select-disabled >>> .ant-select-arrow{
        display: none;
    }
    .btn-box{
        text-align: center;
        padding-bottom: 2rem;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled,.ant-calendar-picker >>> .ant-input[disabled]{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }

</style>
